module.exports = __webpack_public_path__ + "assets/img_goodeggs.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_goodeggs.jpg
 ** module id = 124
 ** module chunks = 1
 **/